import React from "react";
import "./About.css";

const About = () => {
  return (
    <section className="about-section">
      <h2>About Me</h2>
      <p>
        I specialize in creating inspired designs that turn dreams into reality.
        Whether you're decorating your home, elevating your workspace, hosting a holiday gathering,
        or planning a party or special event, I bring your vision to life with intention, creativity, and care.
      </p>
    </section>
  );
};

export default About;